import { Link } from 'react-router-dom';

const stats = [
  { val: '12+', label: 'Städte im Einsatzgebiet' },
  { val: 'seit 2010', label: 'Erfahrung in NRW' },
  { val: '5,0 ★', label: 'Google-Bewertung' },
  { val: '24 Std.', label: 'Angebotserstellung' },
];

export default function LeistungsgebieteHero() {
  return (
    <section className="relative min-h-[480px] md:min-h-[560px] flex items-end overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/2a0388e141ff6b690dc7d4a7ddb825c9.jpg"
          alt="Leistungsgebiete IGM Facility Service NRW Rhein-Ruhr"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D2B4E]/95 via-[#0D2B4E]/55 to-[#0D2B4E]/25" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-14 pt-32">
        {/* Breadcrumb */}
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 mb-5 text-xs text-white/55">
          <Link to="/" className="hover:text-white transition-colors">Startseite</Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-white/90 font-medium">Leistungsgebiete</span>
        </nav>

        <div className="flex items-center gap-2 mb-3">
          <span className="w-8 h-[2px] bg-[#C8A96E]" />
          <span className="text-[#C8A96E] text-xs font-bold tracking-widest uppercase">Einsatzgebiet NRW</span>
        </div>

        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4 max-w-3xl">
          Leistungsgebiete —<br />
          IGM Facility Service in NRW
        </h1>
        <p className="text-white/70 text-sm sm:text-base max-w-2xl leading-relaxed mb-10">
          Von unserem Standort in <strong className="text-white">Ratingen</strong> aus betreuen wir
          Privat- und Gewerbekunden in 12 Städten der Region Rhein-Ruhr — von{' '}
          <strong className="text-white">Düsseldorf</strong> über{' '}
          <strong className="text-white">Mönchengladbach</strong> bis nach{' '}
          <strong className="text-white">Hagen</strong>. Gebäudereinigung, Facility Management,
          Garten- &amp; Landschaftsbau und Renovierungsarbeiten — überall vor Ort verfügbar.
        </p>

        {/* Stats */}
        <div className="flex flex-wrap gap-8 sm:gap-12">
          {stats.map((s) => (
            <div key={s.val}>
              <div className="text-xl sm:text-2xl font-bold text-[#C8A96E]">{s.val}</div>
              <div className="text-xs text-white/55 mt-0.5">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
